import { Banner, BannerFilterableParams, BannerType } from './types';
import { BannerSlugEnum } from '../../@types/bannerEnums';

export type BannerTargeting = Partial<BannerFilterableParams>;

export const findMatchingBanners = (
	banners: Banner[],
	bannerType: BannerType,
	params?: BannerTargeting
): Banner[] => {
	return banners
		.filter((banner) => {
			const conditions = [
				banner.bannerType === bannerType,
				banner.canApplyForRevolving === null ||
					params?.canApplyForRevolving === undefined ||
					banner.canApplyForRevolving === params.canApplyForRevolving,
				banner.hasPlusAccount === null ||
					params?.hasMaxiPackage === undefined ||
					banner.hasPlusAccount === params.hasMaxiPackage,
				banner.slug === null ||
					params?.slugsToExclude === undefined ||
					!params.slugsToExclude.includes(banner.slug as BannerSlugEnum),
			];

			return conditions.every(Boolean);
		})
		.sort((a, b) => {
			const priorityA = a.priority ?? 0;
			const priorityB = b.priority ?? 0;
			return priorityB - priorityA;
		});
};
